import { Component, OnInit, Input, Inject, NgZone } from '@angular/core';
import { HoursService } from '../../services/hours.service';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router, Event, NavigationEnd } from '@angular/router';
import { SearchCategoryResults } from '../../app.models';
import { AppDataService, ASSET_BASE_URL } from '../../app.data.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  MEDIUM_BASE_MEDIA_URL = ASSET_BASE_URL + '/medium';
  validCharsPattern = /[0-9aábcdeéfghijklmnñoópqrstuúüvwxyzAÁBCDEÉFGHIJKLMNÑOÓPQRSTUÚÜVWXYZ' \-]/;

  searchResults: SearchCategoryResults;
  searchResultCategories: string[];
  searching = false;
  searchTimer;
  searchText;

  constructor(private route: ActivatedRoute,
              private hoursService: HoursService,
              private appDataService: AppDataService,
              @Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit() {
  }

  async search(event, searchText) {
    // console.log('search', event);
    if (!this.validCharsPattern.test(event.key) || event.key === 'Shift' || event.key === 'Ctrl' || event.key === 'Alt' || event.key === 'Meta') {
      return;
    }

    if (!!this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    if (!!searchText && searchText !== '') {
      this.searchTimer = setTimeout(async () => {
      //console.log('search(): searching');
        this.searchText = searchText;
        this.searchResultCategories = [];
        this.searchResults = {} as SearchCategoryResults;
        this.searching = true;

        this.searchResults = await this.appDataService.search(searchText);
        this.searchResultCategories = Object.keys(this.searchResults);

      //console.log('search(): done searching', this.searchResultCategories, this.searchResults);
        this.searching = false;
      }, 500);
    } else {
    //console.log('search(): clearing search');
      this.searchTimer = setTimeout(async () => {
        this.searchText = searchText;
        this.searchResults = null;
        this.searchResultCategories = null;
      });
    }
  }

  getNumResults() {
    if (!!this.searchResults && !!this.searchResultCategories) {
      let count = 0;
      this.searchResultCategories.forEach(category => {
        count += this.searchResults[category].length;
      });
      return count;
    }
    return 0;
  }
}
